import React, { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const resetWindowScroll = () => {
  const { scrollingElement, documentElement, body } = document;

  window.scrollTo(0, 0);
  if (scrollingElement) scrollingElement.scrollTop = 0;
  documentElement.scrollTop = 0;
  body.scrollTop = 0;
};

/** Force page top on every route pathname change. */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    resetWindowScroll();
  }, [pathname]);

  // Re-assert after paint — catches StrictMode remounts / late focus scroll.
  useEffect(() => {
    resetWindowScroll();
    const raf = requestAnimationFrame(resetWindowScroll);
    const t0 = window.setTimeout(resetWindowScroll, 0);
    const t1 = window.setTimeout(resetWindowScroll, 50);

    return () => {
      cancelAnimationFrame(raf);
      window.clearTimeout(t0);
      window.clearTimeout(t1);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
